import { useEffect, useState } from 'react'

/**
 * Report whether a CSS media query currently matches.
 *
 * Safe to use during server-side rendering; if the browser `matchMedia` API is unavailable, the hook yields `false`.
 *
 * @param query - A CSS media query string (for example, breakpoint literals from lib/breakpoints)
 * @returns `true` if the media query matches, `false` otherwise
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }
    const mql = window.matchMedia(query)
    setMatches(mql.matches)

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return matches
}
